var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.font_size + ' ' + _vm.margin,attrs:{"href":_vm.href,"width":_vm.width,"border":_vm.border}},[_vm._v(_vm._s(_vm.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }